// extracted by mini-css-extract-plugin
export default {"var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","varSpBase":"1rem","sidebar-wrapper":"sidebar-wrapper--fc9be","sidebarWrapper":"sidebar-wrapper--fc9be"};